<template>
  <div>
    <el-group-title class="group-title">
      <template slot="groupTitle">
        <el-form
          :model="form"
          ref="form"
          label-width="160px"
          class="ccui-form"
          :rules="rules"
        >
          <el-col :span="12">
            <el-form-item label="招标结果：" prop="tenderResult">
              <el-input
                v-model="form.tenderResult"
                placeholder="请选择"
              ></el-input>
              <el-button plain type="single-number" @click="showSingleSelect"
                >关联</el-button
              >
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="项目：" prop="project">
              <el-input
                v-model="form.project"
                placeholder="项管系统项目"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合同编号：" prop="contractNumber">
              <el-input
                v-model="form.contractNumber"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合同名称：" prop="contractName">
              <el-input
                v-model="form.contractName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="采购方式：" prop="procurementMethod">
              <el-select v-model="form.procurementMethod" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="甲方：" prop="owner">
              <el-input v-model="form.owner" placeholder="请选择"></el-input>
              <el-button plain type="single-number">选择</el-button>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="乙方：" prop="secondParty">
              <el-input
                v-model="form.secondParty"
                placeholder="请选择"
              ></el-input>
              <el-button plain type="single-number">选择</el-button>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="项目合同签订人：" prop="signatory">
              <el-input
                v-model="form.signatory"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="签订日期：" prop="signing">
              <el-date-picker
                v-model="form.signing"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="采购计划总编号：" prop="reinforced">
              <el-input
                v-model="form.reinforced"
                placeholder="请选择"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="招标编号：" prop="reference">
              <el-input
                v-model="form.reference"
                placeholder="请选择"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="编制日期：" prop="compileDate">
              <el-date-picker
                v-model="form.compileDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="税率：" :rules="rules.taxRate">
              <el-select v-model="taxRate" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="税额：" prop="assessment">
              <el-input
                v-model="form.assessment"
                placeholder="请选择"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合同总价（含税）：" prop="contract">
              <el-input v-model="form.contract" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合同总价（不含税）：" prop="contractAfterTax">
              <el-input
                v-model="form.contractAfterTax"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="变更后合同总价（含税）：" prop="combustible">
              <el-input
                v-model="form.combustible"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="变更后合同总价（不含税）："
              prop="combustibleNo"
              class="ccui-pre-form-item"
            >
              <el-input
                v-model="form.combustibleNo"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否浮动合同价格：" prop="floating">
              <el-radio v-model="form.floating" label="1">是</el-radio>
              <el-radio v-model="form.floating" label="2">否</el-radio>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="浮动价说明：" prop="floatingTitle">
              <el-input
                v-model="form.floatingTitle"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="价格填写方式：" :rules="rules.responsibility">
              <el-select v-model="responsibility" placeholder="请选择">
                <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="18">
            <el-form-item label="合同主要条款：" prop="mainTerms">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="form.mainTerms"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="18">
            <el-form-item label="备注：" prop="postscript">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="form.postscript"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </el-group-title>
    <el-single-select
      :dataObj="singleSelectData"
      :prop="singleSelectColumn"
      pageSize="10"
      :total="singleSelectPageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :dialogVisible.sync="dialogVisible"
    >
      <template slot="dialogTop">
        <div class="dialog-input">
          商家名称：
          <el-input
            placeholder="请输入商家名称"
            v-model="singleSelectInput.inputMc"
          ></el-input>
        </div>
        <div class="dialog-input">
          商家简称：
          <el-input
            placeholder="请输入商家简称"
            v-model="singleSelectInput.inputJc"
          ></el-input>
        </div>
        <div style="width: 100%;display: flex;justify-content: center">
          <el-button
            size="mini"
            type="primary-font-mini"
            @click="selectSongleSearch"
            >搜索
          </el-button>
          <el-button size="mini" type="default-mini">重置 </el-button>
        </div>
      </template>
    </el-single-select>
  </div>
</template>

<script>
export default {
  props: {
    baseInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      // title: "",
      form: {
        tenderResult: "", // 招标结果
        project: "", // 项目
        contractNumber: "", // 合同编号
        contractName: "", // 合同名称
        procurementMethod: "", // 采购方式
        owner: "", // 甲方
        secondParty: "", // 乙方
        signatory: "", // 项目合同签订人
        signing: "", // 签订日期
        taxRate: "", // 税率
        reinforced: "", // 采购计划总编号
        reference: "", // 招标编号
        compileDate: "", // 编制日期
        contract: "", // 合同总价（含税）
        contractAfterTax: "", // 合同总价（不含税）
        assessment: "", // 税额
        combustible: "", // 变更后合同总价（含税）
        floating: "", // 是否浮动合同价格
        customerName: "",
        combustibleNo: "", // 变更后合同总价（不含税）
        floatingTitle: "", // 浮动价说明
        mainTerms: "", // 合同主要条款
        responsibility: this.baseInfo.responsibility
          ? this.baseInfo.responsibility
          : "", // 价格填写方式
        postscript: "" // 备注
      },
      responsibility: "", // 价格填写方式
      taxRate: "", // 税率
      options: [
        {
          value: "选项1",
          label: "竞争谈判"
        },
        {
          value: "选项2",
          label: "竞争谈判1"
        },
        {
          value: "选项3",
          label: "竞争谈判2"
        },
        {
          value: "选项4",
          label: "竞争谈判3"
        },
        {
          value: "选项5",
          label: "竞争谈判4"
        }
      ],
      options2: [
        {
          value: "0.1",
          label: "0.1"
        },
        {
          value: "0.2",
          label: "0.2"
        },
        {
          value: "0.3",
          label: "0.3"
        },
        {
          value: "0.4",
          label: "0.4"
        },
        {
          value: "0.5",
          label: "0.5"
        }
      ],
      options3: [
        {
          value: "01",
          label: "填写含税价"
        },
        {
          value: "02",
          label: "填写不含税价"
        }
      ],
      rules: {
        contractNumber: [
          { required: true, message: "请输入合同编号", trigger: "change" }
        ],
        contractName: [
          { required: true, message: "请输入合同名称", trigger: "change" }
        ],
        procurementMethod: [
          { required: true, message: "请选择采购方式", trigger: "change" }
        ],
        signatory: [
          { required: true, message: "请输入项目合同签订人", trigger: "change" }
        ],
        reference: [
          { required: true, message: "请输入招标编号", trigger: "change" }
        ],
        compileDate: [
          { required: true, message: "请选择编制日期", trigger: "change" }
        ],
        taxRate: [{ required: true, message: "请选择税率", trigger: "change" }],
        responsibility: [
          { required: true, message: "请选择价格填写方式", trigger: "change" }
        ]
      },
      tableData: [
        {
          id: "1"
        }
      ],
      // 招标结果关联弹窗相关变量 start
      singleSelectInput: {
        inputMc: "",
        inputJc: "",
        inputSj: ""
      },
      singleSelectData: [
        { id: "1", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "2", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "3", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "4", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "5", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "6", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "7", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "8", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "9", mc: "哇哈哈", jc: "哇", sj: "10" },
        { id: "10", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "11", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "21", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "31", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "41", mc: "哇哈哈11", jc: "哇1", sj: "2o" },
        { id: "51", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "61", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "71", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "81", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "91", mc: "哇哈哈1", jc: "哇1", sj: "2o" },
        { id: "110", mc: "哇哈哈", jc: "哇", sj: "11o" }
      ],
      singleSelectColumn: [
        { prop: "mc", label: "商品名称", width: "150" },
        { prop: "jc", label: "商品简称", width: "150" },
        { prop: "sj", label: "入网时间", width: "150" }
      ],
      dialogVisible: false,
      singleSelectPageTotal: 9
      // 招标结果关联弹窗相关变量 end
    };
  },
  watch: {
    baseInfo() {
      this.form = this.baseInfo;
    },
    responsibility() {
      this.$emit("gatResponsibility", this.responsibility);
    },
    taxRate() {
      this.$emit("gatTaxRate", this.taxRate);
    }
  },
  methods: {
    // 招标结果关联弹窗 切换每页条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    // 招标结果关联弹窗 切换页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 招标结果关联弹窗 显示与隐藏
    showSingleSelect() {
      this.dialogVisible = true;
    },
    // 招标结果关联弹窗 点击搜索按钮
    selectSongleSearch() {
      this.singleSelectData = [
        { id: "1", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "2", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "3", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "4", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "5", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "6", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "7", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "8", mc: "哇哈哈", jc: "哇", sj: "1" },
        { id: "9", mc: "哇哈哈", jc: "哇", sj: "10" }
      ];
    }
  }
};
</script>

<style scoped lang="scss">
.group-title {
  /deep/ .el-input {
    width: 260px !important;
  }
  /deep/ .el-button--single-number {
    width: 46px;
    margin-left: 10px;
    padding: 0 9px;
  }
  /deep/.ccui-pre-form-item {
    .el-form-item__label {
      line-height: 16px;
    }
  }
}
</style>
